import {
  hideLoadingSpinner,
  showLoadingSpinner,
  swalAlertDanger,
} from "../components/common/Alerts";
import instanceAPI from "../api/axios.service";

export const getData = async (route) => {
  try {
    const response = await instanceAPI.get(route);
    return response;
  } catch (error) {
    swalAlertDanger("Error al procesar la solicitud", "", () => {});
    return error;
  }
};

export const postData = async (route, data) => {
  try {
    showLoadingSpinner();
    const response = await instanceAPI.post(route, { data: data });
    return response;
  } catch (error) {
    swalAlertDanger("Error al procesar la solicitud", "", () => {});
    return error;
  } finally {
    hideLoadingSpinner();
  }
};

export const putData = async (route, data) => {
  try {
    showLoadingSpinner();
    const response = await instanceAPI.put(route, { data: data });
    return response;
  } catch (error) {
    swalAlertDanger("Error al procesar la solicitud", "", () => {});
    return error;
  } finally {
    hideLoadingSpinner();
  }
};

export const deleteData = async (route) => {
  try {
    showLoadingSpinner();
    const response = await instanceAPI.delete(route);
    return response;
  } catch (error) {
    swalAlertDanger("Error al procesar la solicitud", "", () => {});
    return error;
  } finally {
    hideLoadingSpinner();
  }
};
